import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="bg-white px-4 py-6 md:px-12 md:py-7" data-id="element-153" data-mp="20qnmhm6g4bn0">
      <h2 className="mx-auto max-w-[600px] text-center font-heading text-[22px] font-extrabold uppercase leading-[1.35] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-154" data-mp="1n0ty14yurtdt">
        What speech-language professionals are saying
      </h2>
      <div className="mt-3 space-y-2" data-id="element-155" data-mp="1d09v7xvoqgth">
        {testimonials.map(t => <figure key={t.name} className="rounded-md border border-line bg-[#F5F9FC] px-3 py-2.5" data-id="element-156" data-mp="1i1z3x6vfqiee">
            <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-157" data-mp="1427w5nvihy8u">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden data-id="element-158" data-mp="184ugz4trmiwj" data-mpi={i} />)}
            </div>
            <blockquote className="mt-1 text-[14px] leading-[1.37] text-ink md:text-[15px]" data-id="element-159" data-mp="32gson2cff6qb">“ {t.quote} ”</blockquote>
            <figcaption className="mt-1.5" data-id="element-160" data-mp="2v12kmwj5wb92">
              <span className="block font-heading text-[12px] font-extrabold uppercase text-navy" data-id="element-161" data-mp="2uzrjl4h3phln">
                {t.name}, {t.age}
              </span>
              <span className="block text-[11px] leading-snug text-ink" data-id="element-162" data-mp="34rx8u6fyxkx5">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}